import { render, staticRenderFns } from "./contratoCard.vue?vue&type=template&id=5df7d516&scoped=true"
import script from "./contratoCard.vue?vue&type=script&lang=js"
export * from "./contratoCard.vue?vue&type=script&lang=js"
import style0 from "./contratoCard.vue?vue&type=style&index=0&id=5df7d516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df7d516",
  null
  
)

export default component.exports